<template>
  <div class="row full-width justify-center">
    <div class="column col-12 col-md-4 border-solid text-grey-4 q-pa-xl q-gutter-y-md items-center">

      <!-- logo -->
      <div class="bg-primary q-pa-md" style="border-radius: 1.5rem">
        <q-img src="img/logo-white-medium.png" width="50px" ratio="1"/>
      </div>

      <!-- title -->
      <div class="text-h6 text-bold text-black">
        حامیانه
      </div>

      <!-- description -->
      <div class="text-subtitle2 text-grey-10">
        پلتفرم جامع نیکوکاری
      </div>

      <!-- links -->
      <router-link v-for="link of links" class="full-width" style="text-decoration: none" tag="div" :to="link.link">
        <div class="full-width border-radius bg-primary text-white">
          <div class="row q-pa-md q-gutter-x-md items-center">

            <!-- icon -->
            <q-icon size="sm" :name="link.icon"/>

            <!-- title -->
            <div class="text-subtitle1">
              {{ link.title }}
            </div>

          </div>
        </div>
      </router-link>

      <!-- contact title -->
      <div class="text-subtitle1 text-bold text-black">
        راه‌های ارتباطی
      </div>

      <!-- contact -->
      <div v-for="item of contact"
           class="row full-width border-radius bg-primary q-pa-md justify-between items-center text-white">

        <!-- icon, label -->
        <div class="row q-gutter-x-md items-center">

          <!-- icon -->
          <q-icon size="sm" :name="item.icon"/>

          <!-- label -->
          <div class="text-subtitle1">
            تماس
          </div>

        </div>

        <!-- title -->
        <div class="text-subtitle1">
          {{ item.title }}
        </div>

      </div>

      <!-- social title -->
      <div class="text-subtitle1 text-bold text-black">
        شبکه‌های اجتماعی
      </div>

      <!-- social -->
      <a v-for="link of social" class="full-width" style="text-decoration: none" :href="link.link" target="_blank">
        <div class="full-width border-radius bg-primary text-white">
          <div class="row q-pa-md q-gutter-x-md items-center">

            <!-- icon -->
            <q-icon size="sm" :name="link.icon"/>

            <!-- title -->
            <div class="text-subtitle1">
              {{ link.title }}
            </div>

          </div>
        </div>
      </a>

      <!-- support title -->
      <div class="text-subtitle1 text-bold text-black">
        شبکه‌های اجتماعی
      </div>

      <!-- support -->
      <a v-for="link of support" class="full-width" style="text-decoration: none" :href="link.link" target="_blank">
        <div class="full-width border-radius bg-primary text-white">
          <div class="row q-pa-md q-gutter-x-md items-center">

            <!-- icon -->
            <q-icon size="sm" :name="link.icon"/>

            <!-- title -->
            <div class="text-subtitle1">
              {{ link.title }}
            </div>

          </div>
        </div>
      </a>

    </div>
  </div>
</template>

<script>
import {useMeta} from "quasar";

export default {
  name: "Nav",
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    await store.dispatch('getMeta', {pageUrl: 'https://www.hamiane.com/nav'})
    let meta = {}
    meta.title = store.state.preFetch.pageMeta.metaTitle
    meta.description = store.state.preFetch.pageMeta.metaDescription
    meta.keywords = store.state.preFetch.pageMeta.metaKeywords
    meta.script = null
    return await store.dispatch('setMeta', meta)
  },
  data: () => ({
    links: [
      {icon: 'la la-globe', title: 'سایت حامیانه', link: '/'},
      {icon: 'la la-newspaper', title: 'کاتالوگ حامیانه', link: '/catalog'},
      {icon: 'la la-registered', title: 'ثبت‌نام موسسات', link: '/pricing'}
    ],
    contact: [
      {icon: 'la la-phone', label: 'تماس', title: '05136010560'}
    ],
    social: [
      {icon: 'la la-instagram', title: 'اینستاگرام', link: 'https://instagram.com/hamiane_com'},
      {icon: 'la la-telegram', title: 'تلگرام', link: 'https://t.me/hamiane_com'}
    ],
    support: [
      {icon: 'la la-whatsapp', title: 'واتساپ', link: 'https://wa.me/989334241634/?text='}
    ]
  }),
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    }
  },
  async mounted() {
    await useMeta(this.$store.state.meta)
    this.$store.commit('setPageLoadState', true)
  }
}
</script>

<style scoped>

</style>
